import { SlashCommand } from './types';

export const aiToolsCommands: SlashCommand[] = [
    { id: 'image', name: 'Generate Image', trigger: '/image', description: 'Generate an AI image', category: 'Creative', icon: 'fa-image', mode: 'tool', tool: 'image-generation', prefix: 'generate an image of: ', integration: 'Ai-Tools' },
    { id: 'search', name: 'Web Search', trigger: '/search', description: 'Search the web for current info', category: 'Research', icon: 'fa-magnifying-glass', mode: 'tool', tool: 'web-search', prefix: 'search the web for: ', integration: 'Ai-Tools' }
];
